import useSecurity from "../../../use/useSecurity";
import useEntrepreneurRepository from "../../../repository/user/useEntrepreneurRepository";
import {useEffect, useState} from "react";
import isNull from "../../../mixin/isNull";
import useLegalDocumentTemplateRepository from "../../../repository/user/useLegalDocumentTemplateRepository";
import useLegalDocumentRepository from "../../../repository/user/useLegalDocumentRepository";
import {Badge, IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {Notifications, PictureAsPdf} from "@mui/icons-material";
import Modal from "../../../material/modal/Modal";
import ModalConfig from "../../../material/modal/ModalConfig";
import UploadDocument from "./legal-document/UploadDocument";
import useHelper from "../../../use/useHelper";
import useInformationMessageRepository from "../../../repository/user/useInformationMessageRepository";
import InformationMessage from "../../../entity/user/InformationMessage";

export default function () {
    const security = useSecurity();
    const helper = useHelper();
    const entrepreneurRepository = useEntrepreneurRepository();
    const legalDocumentTemplateRepository = useLegalDocumentTemplateRepository();
    const legalDocumentRepository = useLegalDocumentRepository();
    const informationMessageRepository = useInformationMessageRepository();
    /** @type Entrepreneur */
    const entrepreneur = entrepreneurRepository.findOneById(security.id).select();
    /** @type LegalDocumentTemplate[] */
    const legalDocumentTemplates = legalDocumentTemplateRepository.findAll().select();
    /**@type LegalDocument[] */
    const legalDocuments = legalDocumentRepository.findAllByCompanyIdToProvide(entrepreneur?.getCompanyId()).select();
    /** @type InformationMessage[] */
    const informationMessages = informationMessageRepository.findAllByRecipientType(InformationMessage.RECIPIENT_TYPE_ARTISAN).select();

    const [anchorEl, setAnchorEl] = useState(null);
    const [legalDocumentSelected, setLegalDocumentSelected] = useState(null);
    const [notifications, setNotifications] = useState([]);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const toggleLegalDocumentSelected = id => () => {
        setLegalDocumentSelected(id);
        handleClose();
    }

    useEffect(() => {
        entrepreneurRepository.findOneById(security.id).exec();
        legalDocumentTemplateRepository.findAll().exec();
        informationMessageRepository.findAllByRecipientType(InformationMessage.RECIPIENT_TYPE_ARTISAN).exec();
    }, []);

    useEffect(() => {
        if (isNull(entrepreneur)) return;

        legalDocumentRepository.findAllByCompanyId(entrepreneur.getCompanyId()).exec();
    }, [JSON.stringify(entrepreneur)]);

    useEffect(() => {
        toggleLegalDocumentSelected(null)();
        groupMessages();
    }, [JSON.stringify(legalDocuments), JSON.stringify(informationMessages), JSON.stringify(legalDocumentTemplates)]);


    const groupMessages = () => {
        if (isNull(legalDocuments) || isNull(legalDocumentTemplates) || isNull(informationMessages)) return;

        let notifications = [];

        legalDocuments.forEach(ld => {
            notifications.push(
                <MenuItem key={ld.getId()} onClick={toggleLegalDocumentSelected(ld.getId())}
                          data-test="legal-document-menu-item">
                    <ListItemIcon>
                        <PictureAsPdf/>
                    </ListItemIcon>
                    <ListItemText>
                        {legalDocumentTemplates.find(ldt => ldt.getId() === ld.getLegalDocumentTemplateId())?.getName()} à
                        fournir
                    </ListItemText>
                </MenuItem>
            );
        });

        informationMessages.reverse().forEach(im => {
            notifications.push(
                <MenuItem
                    key={im.getId()}
                    sx={{display: "flex", flexDirection: 'column', alignItems: "flex-start"}}
                >
                    <ListItemText
                        primary={im.getContent()}
                        primaryTypographyProps={{style: {whiteSpace: "normal"}}}
                    />

                    <ListItemText primaryTypographyProps={{fontSize: "small"}}>
                        {helper.formatDate(im.getCreatedAt())}
                    </ListItemText>
                </MenuItem>
            );
        });

        setNotifications(notifications);
    }

    if (notifications.length === 0) return null;

    return (
        <>
            <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
                data-test={"button-notification"}
            >
                <Badge
                    badgeContent={notifications.length}
                    color={"error"}
                    children={<Notifications/>}
                />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {notifications}
            </Menu>

            {
                !isNull(legalDocumentSelected)
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setWidth("100%")
                                    .setHeight("100%")
                                    .setOnClose(toggleLegalDocumentSelected(null))
                                    .setComponent(<UploadDocument legalDocumentId={legalDocumentSelected}/>)
                            }
                        />
                    )
                    : null
            }
        </>
    )
}